import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

interface StyledGridProps {
  columns?: number;
}

interface StyledGridItemProps {
  columnIndex?: number;
}

export const StyledGrid = styled(Box)<StyledGridProps>(({ columns = 1 }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columns}, minmax(auto, 1fr))`,
  gap: 48,
}));

export const StyledGridItem = styled(Box, {
  shouldForwardProp: (prop: PropertyKey) => prop !== 'columnIndex',
})<StyledGridItemProps>(({ theme, columnIndex }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  borderRight:
    columnIndex !== undefined && columnIndex % 2 === 0
      ? `1px solid ${theme.palette.divider}`
      : 'none',
  padding: '0 24px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 4,
}));
